import { useEffect } from 'react'

/**
 * Escape closes this popover before the global ladder acts.
 *
 * The chip popovers, the sources popover and the sidebar's own are local
 * component state, so the Escape ladder in App.tsx cannot see them: Escape
 * left the popover open and acted on the layer beneath it — deselecting the
 * node under a menu the user was trying to dismiss, with a misclick into the
 * still-open menu as the follow-up. Capture phase, so this fires before the
 * ladder's bubble listener; stopPropagation keeps the one keypress to the one
 * layer it dismissed, which is the ladder's own contract.
 */
export function useEscapeToClose(active: boolean, close: () => void) {
  useEffect(() => {
    if (!active) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return
      e.stopPropagation()
      close()
    }
    window.addEventListener('keydown', onKey, true)
    return () => window.removeEventListener('keydown', onKey, true)
  }, [active, close])
}
